/** The texts of the sites workspace's column and boards, spread into the app's dictionaries (`lib/i18n.tsx`). */
export const sitesEn = {
  notice_site_role: 'Your role at {site}: {role}',
  notice_site_role_ended: 'You no longer belong to {site}',
  boardManage: 'Administration',
  coordination: 'Coordination',
  groupUploads: 'Uploads and storage',
  groupPeople: 'People and access',
  groupSite: 'Agreements and the site',
  noSitesOrganized: 'You organize the work of no site.',
  switchSite: 'Switch site: {site}',
  findSite: 'Find a site',
  uploadsUnlock: 'Unlock uploads',
  uploadsOpen: 'Uploads open',
  uploadsLocked: 'locked',
  stepDone: 'done',
  stepTodo: 'to do',
  tokenSummary: '“{label}” · since {date}',
  patientIds: 'Patient IDs and time zone',
  patientIdsIntro: 'How this site writes its patient IDs. A file whose patient ID fits no active form, is a placeholder or repeats one character, such as 0000000000, is held and never changed.',
  idShortest: 'Shortest',
  idLongest: 'Longest',
  idCharacters: 'Characters',
  idDigits: 'Digits',
  idAlphanumeric: 'Digits and letters',
  idPrefix: 'Fixed beginning · optional',
  idRetired: 'Retired for new uploads',
  addIdForm: 'Add a form',
  idFormsHint: 'A numbering that changed keeps its old form, retired: its IDs are still looked up. Saved forms are never removed.',
  idPlaceholders: 'Placeholders for unknown patients · optional',
  idPlaceholdersHint: 'One per line, as in the files.',
  siteTimeZone: 'Time zone',
  siteTimeZoneHint: 'Times in files that state no time zone of their own are read in it.',
  siteTimeZoneOnce: 'The time zone is set once, then fixed',
  siteCheck: 'Check the site’s files',
  siteCheckIntro: 'Choose a sample of the site’s DICOM files. They are read in this browser without the token and never uploaded; the check shows only counts.',
  siteCheckFiles: 'Choose files',
  siteCheckFolder: 'Choose a folder',
  siteCheckRunning: 'Reading {done} of {total} files…',
  siteCheckRead: '{count} files read.',
  siteCheckRead_one: '1 file read.',
  siteCheckUnread: '{count} could not be read, for example because they are not DICOM images.',
  siteCheckForms: 'Forms of the patient IDs',
  siteCheckForm: '{length} {characters}, beginning with {first}',
  siteCheckDigits: 'digits',
  siteCheckAlphanumeric: 'digits and letters',
  siteCheckOther: 'characters, not only digits and letters',
  siteCheckIssuers: 'Issuers of Patient ID',
  siteCheckInstitutions: 'Institutions',
  siteCheckZones: 'Time zones the files state',
  siteCheckLacking: 'Files without',
  siteCheckNoSide: 'a side',
  siteCheckNoRegion: 'a body region',
  siteCheckNoView: 'a projection',
  siteCheckNone: 'none',
  uploadsNeedSteps: 'Open once the steps above are done.',
  agreementBlocks: 'The data processing agreement is missing or has ended. The platform renews it.',
  dpaMissingShort: 'missing',
  extend: 'Extend',
  untilDate: 'until {date}',
  byPlatform: 'kept by the platform',
  ethicsApproval: 'Ethics approval',
  retention: 'Retention',
  siteStanding: 'Agreement and deadlines',
  locationAdd: 'Add location',
  locationKind: 'Kind of location',
  locationBucket: 'S3 bucket',
  locationBucketDetail: 'Reachable from the internet',
  locationConnector: 'Site connector',
  locationConnectorDetail: 'A folder or S3 in the hospital network',
  locationCloud: 'Cloud drive',
  locationCloudDetail: 'Google Drive · Dropbox',
  locationNextcloud: 'Nextcloud',
  locationNextcloudDetail: 'A folder, after logging in once',
  sitePeopleByAdmins: 'The site’s admins manage its people. A platform admin appoints a site admin only while the site has none, and never themselves.',
  appointSiteAdmin: 'Appoint a site admin',
  memberDeactivated: 'deactivated',
}

export const sitesDe: Record<keyof typeof sitesEn, string> = {
  notice_site_role: 'Ihre Rolle am Standort {site}: {role}',
  notice_site_role_ended: 'Sie gehören nicht mehr zum Standort {site}',
  boardManage: 'Verwaltung',
  coordination: 'Koordination',
  groupUploads: 'Uploads und Speicher',
  groupPeople: 'Personen und Zugang',
  groupSite: 'Vereinbarungen und Standort',
  noSitesOrganized: 'Sie organisieren die Arbeit keines Standorts.',
  switchSite: 'Standort wechseln: {site}',
  findSite: 'Standort suchen',
  uploadsUnlock: 'Uploads freischalten',
  uploadsOpen: 'Uploads offen',
  uploadsLocked: 'gesperrt',
  stepDone: 'erledigt',
  stepTodo: 'offen',
  tokenSummary: '„{label}“ · seit {date}',
  patientIds: 'Patienten-IDs und Zeitzone',
  patientIdsIntro: 'Wie dieser Standort seine Patienten-IDs schreibt. Eine Datei, deren Patienten-ID zu keiner aktiven Form passt, ein Platzhalter ist oder nur ein Zeichen wiederholt, etwa 0000000000, wird zurückgehalten und nie geändert.',
  idShortest: 'Kürzeste',
  idLongest: 'Längste',
  idCharacters: 'Zeichen',
  idDigits: 'Ziffern',
  idAlphanumeric: 'Ziffern und Buchstaben',
  idPrefix: 'Fester Anfang · optional',
  idRetired: 'Für neue Uploads stillgelegt',
  addIdForm: 'Form hinzufügen',
  idFormsHint: 'Eine geänderte Nummerierung behält ihre alte Form, stillgelegt: Ihre IDs werden weiter nachgeschlagen. Gespeicherte Formen werden nie entfernt.',
  idPlaceholders: 'Platzhalter für unbekannte Patienten · optional',
  idPlaceholdersHint: 'Einer pro Zeile, wie in den Dateien.',
  siteTimeZone: 'Zeitzone',
  siteTimeZoneHint: 'Zeiten in Dateien, die keine eigene Zeitzone angeben, werden in ihr gelesen.',
  siteTimeZoneOnce: 'Die Zeitzone wird einmal festgelegt, danach ist sie fix',
  siteCheck: 'Dateien des Standorts prüfen',
  siteCheckIntro: 'Wählen Sie eine Stichprobe der DICOM-Dateien des Standorts. Sie werden in diesem Browser ohne Token gelesen und nie hochgeladen; die Prüfung zeigt nur Anzahlen.',
  siteCheckFiles: 'Dateien wählen',
  siteCheckFolder: 'Ordner wählen',
  siteCheckRunning: '{done} von {total} Dateien gelesen …',
  siteCheckRead: '{count} Dateien gelesen.',
  siteCheckRead_one: '1 Datei gelesen.',
  siteCheckUnread: '{count} ließen sich nicht lesen, etwa weil sie keine DICOM-Bilder sind.',
  siteCheckForms: 'Formen der Patienten-IDs',
  siteCheckForm: '{length} {characters}, beginnend mit {first}',
  siteCheckDigits: 'Ziffern',
  siteCheckAlphanumeric: 'Ziffern und Buchstaben',
  siteCheckOther: 'Zeichen, nicht nur Ziffern und Buchstaben',
  siteCheckIssuers: 'Aussteller der Patienten-ID (Issuer of Patient ID)',
  siteCheckInstitutions: 'Einrichtungen',
  siteCheckZones: 'Zeitzonen, die die Dateien angeben',
  siteCheckLacking: 'Dateien ohne',
  siteCheckNoSide: 'Seite',
  siteCheckNoRegion: 'Körperregion',
  siteCheckNoView: 'Projektion',
  siteCheckNone: 'keine',
  uploadsNeedSteps: 'Offen, sobald die Schritte oben erledigt sind.',
  agreementBlocks: 'Der AV-Vertrag fehlt oder ist abgelaufen. Die Plattform erneuert ihn.',
  dpaMissingShort: 'fehlt',
  extend: 'Verlängern',
  untilDate: 'bis {date}',
  byPlatform: 'von der Plattform',
  ethicsApproval: 'Ethikvotum',
  retention: 'Aufbewahrung',
  siteStanding: 'Vertrag und Fristen',
  locationAdd: 'Speicherort hinzufügen',
  locationKind: 'Art des Speicherorts',
  locationBucket: 'S3-Bucket',
  locationBucketDetail: 'Aus dem Internet erreichbar',
  locationConnector: 'Standort-Connector',
  locationConnectorDetail: 'Ordner oder S3 im Kliniknetz',
  locationCloud: 'Cloud-Laufwerk',
  locationCloudDetail: 'Google Drive · Dropbox',
  locationNextcloud: 'Nextcloud',
  locationNextcloudDetail: 'Ein Ordner, nach einmaliger Anmeldung',
  sitePeopleByAdmins: 'Die Personen eines Standorts verwaltet seine Standort-Administration. Die Plattform-Administration ernennt eine Standort-Administration nur, solange der Standort keine hat, und nie sich selbst.',
  appointSiteAdmin: 'Standort-Administration ernennen',
  memberDeactivated: 'deaktiviert',
}
